import styled from 'styled-components';
import Icon from '../Icon/IconSVG';

export const Root = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const Title = styled.p`
  position: relative;
  display: block;
  font-family: ${props => props.theme.font.heading4.fontFamily};
  font-size: ${props => props.theme.font.heading4.fontSize};
  line-height: ${props => props.theme.font.heading4.lineHeight};
  color: ${props => props.theme.color.brand.primary};
  cursor: pointer;
`;

export const TitleIcon = styled(Icon)`
  display: block;
  transform: ${props => (props.isActive ? 'rotate(-180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease-in-out 0s;
`;

export const Content = styled.div`
  display: block;
  margin-top: ${({ isActive }) => (isActive ? '10' : '0')}px;
  max-height: ${props => !props.isActive && 0};

  p {
    font-family: ${props => props.theme.font.body2.fontFamily};
    font-size: ${props => props.theme.font.body2.fontSize};
    line-height: ${props => props.theme.font.body2.lineHeight};
    color: ${props => props.theme.color.brand.grey};
    margin: ${props => props.theme.layout.gutter / 2}px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${props => props.theme.color.brand.accent};
    text-decoration: none;
  }

  overflow: hidden;
  transition: max-height 3s cubic-bezier(0, 1, 0, 1) 0s;
`;
